import { render, staticRenderFns } from "./MenuBarColorButton.vue?vue&type=template&id=d0ff7316"
import script from "./MenuBarColorButton.vue?vue&type=script&lang=js"
export * from "./MenuBarColorButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports